export default {
    "vehicles": {
        "titles": "Viaturas",
        "title": "Viatura",
        "list": {
            "unity": "@:vehicles.model.unity",
            "code": "@:vehicles.model.code",
            "registration": "@:vehicles.model.registration",
            "radio": "@:vehicles.model.radio",
            "active": "@:vehicles.model.active",
        },
        "model": {
            "registration": "Matrícula",
            "radio": "Rádio", //E/R Móveis
            "active": "Operacional",
            "operability_type": "Estado",
            "gps": "GPS",
            "entity": "Entidade",
            "unity": "Unidade",
            "code": "Código",
            "description": "Descrição",
            "manufacturer": "Marca",
            "model": "Modelo",
            "year": "Ano",
            "engine": "Cilindrada",
            "num_seats": "Lotação",
            "fuel_type": "Tipo Combustível",
            "vehicle_type": "Tipo",
            "vehicle_class": "Categoria",
            "gearbox_type": "Tipo Transmissão",
            "obs": "Observações",
        },
        "help": {
            "entity": "Configurar entidade a que pertence a @:vehicles.title",
            "unity": "Configurar unidade a que pertence a @:vehicles.title"
        }
    },
    "radios": {
        "titles": "Rádios",
        "title": "Rádio",
        "list": {
            "unity": "@:radios.model.unity",
            "radio_type": "@:radios.model.radio_type",
            "code": "@:radios.model.code",
            "active": "@:radios.model.active"
        },
        "model": {
            "entity": "Entidade",
            "unity": "Unidade",
            "radio_type": "Tipo",
            "code": "Código",
            "active": "Operacional"
        },
        "help": {
            "entity": "Configurar entidade a que pertence o @:radios.title",
            "unity": "Configurar unidade a que pertence o @:radios.title"
        }
    },
    "terrestrialresources": {
        "titles": "Meios Terrestres",
        "title": "Meio Terrestre",
        "list": {
            "unity": "@:terrestrialresources.model.unity",
            "type": "@:terrestrialresources.model.terrestrial_resource_type",
            "code": "@:terrestrialresources.model.code",
            "active": "@:terrestrialresources.model.active", //"Operacional"
        },
        "model": {
            "active": "Operacional",
            "entity": "Entidade",
            "unity": "Unidade",
            "code": "Código",
            "name": "Nome",
            "description": "Descrição",
            "address": "Morada",
            "email": "E-mail",
            "phone": "Contato",
            "lat": "Latitude",
            "lng": "Longitude",
            "contracted_entity": "Entidade Contratada",
            "n_vehicles": "Nº de Viaturas",
            "n_operationals": "Nº de Operacionais",
            "terrestrial_resource_type": "Tipo",
        },
        "help": {
            "entity": "Configurar entidade a que pertence a @:terrestrialresources.title",
            "unity": "Configurar unidade a que pertence a @:terrestrialresources.title",
            "email": "É possivel configurar múltiplos e-mails separados por <b>,</b> ou <b>;</b>",
            "phone": "É possivel configurar múltiplos telefone/telemóvel separados por <b>,</b> ou <b>;</b>",
            "lat": "Ex - 40° 26′ 46″ N ou 40° 26′ 45.9996″ N",
            "lng": "Ex - 79° 58′ 56″ W ou 79° 58′ 55.2″ E"
        }
    },
    "aerialresources": {
        "titles": "Meios Aéreos",
        "title": "Meio Aéreo",
        "list": {
            "unity": "Unidade",
            "type": "Tipo",
            "air_base": "CMA",
            "code": "Código",
            "active": "", //"Operacional"
        },
        "model": {
            // "active": "Operacional",
            "entity": "Entidade",
            "unity": "Unidade",
            "air_base": "CMA",
            "code": "Código",
            "description": "Descrição",
            "manufacturer": "Marca",
            "model": "Modelo",
            "year": "Ano",
            "engine": "Motor",
            "num_seats": "Lotação",
            "aerial_resource_type": "Tipo",
            "operability_type": "Estado",
        },
        "help": {
            "entity": "Configurar entidade a que pertence a @:aerialresources.title",
            "unity": "Configurar unidade a que pertence a @:aerialresources.title",
            "air_base": "Centro de Meios Aéreos"
        }
    },
    "agents": {
        "titles": "Agentes",
        "title": "Agente",
        "list": {
            "entity": "Entidade",
            "unities": "Unidades",
            "code": "Código",
            "code_internal": "Cód. Interno",
            "name": "Nome",
            "patent": "Patente",
            "category_type": "Categoria",
            'shift_graduate': 'Grad. Turno',
            'central_operational': 'Op. Central',
            "active": "Operacional",
            "available": ""
        },
        "form": {
            "unity": {
                "entity": "Entidade",
                "unity": "Unidade",
                "name": "Unidade",
                "no_data": "Sem unidades associadas",
                "add_unity": "Unidade",
                "remove_unity": "Remover",
                "deleteMsg": "Deseja remover a unidade <u>{name}</u>?",
            }
        },
        "model": {
            "code": "Código",
            "code_internal": "Código Interno",
            "name": "Nome",
            "shift_graduate": "Graduado de Turno",
            'central_operational': 'Operacional Central',
            "email": "E-mail",
            "phone": "Contato",
            "patent": "Patente",
            "category_type": "Categoria",
            "formation": "Formação",
            "professional_experience": "Experiência Profissional",
            "specialties": "Especialidades",
            "obs": "Outras Informações Relevantes",
            "active": "Operacional",
            "absences": "Ausências",
            "absence": {
                "type": "Tipo",
                "time": "Período"
            }
        },
        "help": {
            "entity": "Configurar entidade a que pertence o @:agents.title",
            "unity": "Configurar unidade a que pertence o @:agents.title"
        }
    },
    "communications": {
        "titles": "Comunicações",
        "title": "Comunicação",
        "list": {

        },
        "model": {
            "tabs": {
                "commun": "Geral",
                "entities": "@:communications.model.entities.title",
                "resources": "@:communications.model.resources.title",
                "victims": "@:communications.model.victims.title",
                "expeditient": "@:communications.model.expeditient.title",
                "posits": "@:communications.model.posits.title",
            },
            "name": "Nome",
            "code_cdos": "Nº Ocorrência CDOS",
            "family": "Família",
            "kind": "Espécie",
            "type": "Tipo",
            "category": "Tipo de Registo",
            "channel": "Canal de Entrada",
            "description": "Descrição",
            "diligence": "Diligência",
            "operational_code": "Código Operacional",
            "obs": "Observações",
            "date": "Data",
            "agent": "Agente",

            "address": {
                "title": "Localização",
                "coordinates": "{lat}, {lng}",
                "local": "Ponto de Interesse...",
                "district": "Distrito",
                "municipality": "Concelho",
                "parish": "Freguesia",
                "street": "Morada...",
                "fraction": "Fração",
                "reference_point": "Ponto de Referência",
                "designation": "Designação"
            },
            "occurrence": "Dados da Ocorrência",
            "operational_code": "Código Operacional",

            "claimant":  {
                "title": "Dados da Pessoa",
                "name": "Nome",
                "phone": "Contato",
                "email": "E-mail",
                "address": "Morada",
            },

            "inspection_traffic": {
                "title": "Expediente Transito",

            },

            "inspection_value": {
                "title": "Valores Colocados Cofre",

            },

            "inspection_active": {
                "title": "Dados da Pessoa",

            },

            "update_process": {
                "title": "Processos Administrativos",

            },

            "expeditient":  {
                "title": "Expediente",
                "notes": "Dados do Expediente",
            },

            "entities":  {
                "title": "Entidades Presentes",
            },

            "posits":  {
                "title": "Pontos de Situação (POSIT)",
                "generic_title": "POSIT",
                "date": "Hora",
                "status": "Estado",
                "obs": "Observações",
                "entity": {
                    "name": "Entidade",
                    "list": {
                        "entity": "Entidade",
                        "n_operationals": "Operacionais",
                        "n_vehicles": "Veículos"
                    }
                }
            },

            "victims":  {
                "title": "Vítimas",
                "type": "Tipo",
                "status": "Estado",
                "number": "Número",
                "dislodged": {
                    "title": "Desalojados",
                    "number": "Nº de Desalojados",
                    "obs": "Descrição",
                },
                "damage_caused": "Danos Causados"
            },

            "resources": {
                "title": "Recursos Físicos e Humanos",
                "land": {
                    "title": "Meios Terrestres",
                    "name": "Meio Terrestre",
                    "code": "Código",
                    "number": "Nº",
                    "date": "Hr TO",
                    "mission": "Missão",
                },
                "aerial": {
                    "title": "Meios Aéreos",
                    "name": "Meio Aéreo",
                    "code": "Código",
                    "number": "Nº",
                    "date": "Hr TO",
                    "mission": "Missão",
                },
                "other": {
                    "title": "Outros Meios Presentes",
                    "name": "Nome",
                    "date": "Hr TO"
                },
                "activity": {
                    "generic_title": "Atividade do Recurso",
                    // "title": "{name} de {unity}",
                    "title": "{name}",
                    "status": "Estado",
                    "date": "Hora",
                    "obs": "Observações",
                }
            },

            // "light_aerialtanks": "Aerotanques Ligeiros",
            // "heavy_aerialtanks": "Aerotanques Pesados",
            // "light_helicopters": "Helicópteros Ligeiros",
            // "medium_helicopters": "Helicópteros B. Médios",
            // "heavy_helicopters": "Helicópteros B. Pesados",
            // "coordination_helicopters": "Helicópteros Coordenação",

            "emergency_active_plans": "Planos de Emergência Ativados",
            "emergency_municipal_plan": "Municipal",
            "emergency_district_plan": "Distrital",
            "emergency_national_plan": "Nacional",
            "emergency_special_plan": "Especial"
        },
        "actions": {
            "filter": "Filtrar os dados",
            "reload": "Atualizar os dados",
            "reset": "Limpar",
            "search": "Pesquisar",
        }
    },
    "shifts": {
        "titles": "Turnos",
        "title": "Turno",
        "actions": {
            "add_shift": "Adicionar Turno",
        }
    }
}